export default "__VITE_ASSET__NIXjPRhX__"